import * as React from 'react';
import theme from '../theme/theme';
import { Avatar, Box, Button, Grid, IconButton, TextField, Tooltip, Typography, styled } from "@mui/material";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgressComponent = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[50],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.primary.main,
    },
}));

const BorderLinearProgress = (props) => {

    return (

        <BorderLinearProgressComponent 
        variant="determinate" 
        value={props.value} 
        />

    )

};
export default BorderLinearProgress;